import type { FeatureBlockData } from '@af/design-system-docs-ui/feature-block-grid';

// oxlint-disable import/extensions -- PNG imports require explicit extension for eslint's no-unresolved
import principle1 from '../_assets/principles/1.png';
import principle2 from '../_assets/principles/2.png';
import principle3 from '../_assets/principles/3.png';
// oxlint-enable import/extensions

export const principles: FeatureBlockData[] = [
	{
		title: 'Optimize for readability',
		description:
			'Help readers understand communications easily and enhance their experience, regardless of their abilities.',
		image: { src: principle1, alt: '' },
	},
	{
		title: 'Create visual harmony',
		description:
			'Typography should be consistent and cohesive. Use visual hierarchy and space to simplify complex information.',
		image: { src: principle2, alt: '' },
	},
	{
		title: 'Contextualize for different users',
		description:
			'Tailor for different preferences, operating systems and applications, while keeping in mind how people consume and process information.',
		image: { src: principle3, alt: '' },
	},
];
